export default "__VITE_ASSET__58fead91__"